import DatePicker from 'vue2-datepicker';
import envVar from '../../js/lib/envVar';
import request from '../../js/lib/request';
import changeClass from '../../js/lib/changeClass.js';
import currentLang from '../../js/lib/currentLang.js';
import raf from '../../js/lib/raf';
import urlVars from '../../js/lib/urlVars';
import showTagList from '../../js/lib/showTagList';

// search engine code (EC)
if(document.getElementById('SearchEngine'))
{
	Vue.use(DatePicker);
	var moment = require('moment');

	const options = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		}
	};

	// get init search text value from html via mvc
	const initSearch = document.getElementById('SearchText');

	// Use different URL for Static/MVC
	const initUrl = envVar({
		backendPath:'/SearchPage/InitSearch/',
		staticPath: 'js/data/searchInit.json'
	});

	const refreshUrl = envVar({
		backendPath:'/SearchPage/RefreshSearch/',
		staticPath: 'js/data/searchRefresh.json'
	});

	const clickTrackingUrl = envVar({
	    backendPath:'/SearchPage/Track/',
	});

	const refreshFacetsUrl = envVar({
		backendPath:'/SearchPage/RefreshFacets/',
		staticPath: 'js/data/searchRefresh.json'
	});

	const refreshPagingUrl = envVar({
		backendPath:'/SearchPage/RefreshPaging/',
		staticPath: 'js/data/searchRefresh.json'
	});

	const vueComponentName = new Vue({
		components: { DatePicker },
		el: '#SearchEngine',
		data: {
			// main search objects
			facets: '',
			searchResults: '',
			bestBetsResults:'',
			pagination:{ 
				'pageCount': 999, // initial pagination object, needed for jumping to pages
				'displayCount': 10,
				'currentIndex': 1,
				'currentIndexTake': 10,
				'listPages': [
					1,
					2,
					3
				]
			},
            trackId: '',
			searchText: '',
			pageType: '',
			alwaysInclude: '',
			alwaysPageRoot: '',
            metricsLog: 0,
            searchAllSites: false,

			// query string/pass objects to server
			postData: '',
			catlist: [],
			currentYear: '',
			qsData: {
				'Authors': [],	
				'Language': '',	
				'Private': [],	
				'StartDate': moment().subtract(12, 'month'),
				'EndDate': '',
				'TargetType': '',
				'SelectSort': 'relevance',
				'SelectDisplayCount': 10,
				'CurrentPageNum': 1,
				'MetricsLogGUID': 0,
			},

			// ui
			// - display output
			displayText: '',
		    // - show/hide ui, do loaders
            applyFilterTarget: '',
            showFilters: true,
            showAllFilterTags: false,
			resultsLoading: false,
			facetsLoading: true,
			pagingLoading: true,
            filterTagCount: 0,
		},
		watch: {
			resultsLoading: function () {
				const self = this;

				if (self.resultsLoading == true) {
					// animate the scroll to top (taken from BF)
					self.doScroll();
				}
			}
		},
		computed: {
			startDateCom: function() {
				const self = this;
				return moment(self.qsData.StartDate, 'YYYY-MM-DD').format('MM/DD/YYYY');
			},
			endDateCom: function() {
				const self = this;
				return moment(self.qsData.EndDate, 'YYYY-MM-DD').format('MM/DD/YYYY');
			},
		},
		// When Component is Mounted, run Methods
		mounted: function() {
			const self = this;

			self.qsData.metricsLogGUID = initSearch.getAttribute('data-metriclogid');

			self.initResults();

			self.$refs['filterOpen'].addEventListener('click', (event)=>{
				event.currentTarget.nextElementSibling.setAttribute('data-open', true);
				changeClass.addClass('body','body--FREEZE');
			}, false);

			self.$refs['filterClose'].addEventListener('click', (event)=>{
				event.currentTarget.parentElement.removeAttribute('data-open');
				changeClass.removeClass('body','body--FREEZE');
			}, false);


			// this window listener will setup pagination when we get a "back" event
			if(window.addEventListener)
			{
				window.addEventListener('popstate', function(event) {
					var qs = urlVars();
					if(qs['t'] || qs['q'] || qs['b'] || qs['c'] || qs['qs'])
					{
						if(qs['t'])
							self.qsData.TargetType = qs['t'];
						if(qs['q'])
							self.searchText = qs['q'];
						if(qs['c'])
							self.catlist = qs['c'].split(',');
						if(qs['qs'])
							self.qsData = JSON.parse(decodeURIComponent(qs['qs']));
						else
							self.qsData.CurrentPageNum = 1;

						if(qs['b'] && !qs['qs'])
							self.initResults();
						else
							self.jumpToPage(self.qsData.CurrentPageNum, true, true);
					}
				});
			}
		},
		// Methods
		methods: {
			loadData: function(inData) {
				const self = this;
				// debugger;
				self.facets = inData.facets;
				self.searchText = inData.searchText;
				self.pageType = inData.pageType;
				self.qsData.TargetType = inData.targetType;
				self.alwaysInclude = inData.alwaysInclude;
				self.alwaysPageRoot = inData.alwaysPageRoot;
                self.qsData.SelectSort = inData.pagination.sortBy;
                self.searchAllSites = inData.searchAllSites;
				if(moment(inData.startDate).year() > 1990)
					self.qsData.StartDate = inData.startDate;
				if(moment(inData.endDate).year() > 1990)
					self.qsData.EndDate = inData.endDate;

				self.refreshFilters();
			},
			showTags: function() {
				const self = this;

				self.showAllFilterTags = true;
			},
			refreshFilters: function() {
				const self = this;

				// setup showFilters
				self.showFilters = false;
				self.catlist = [];
				self.filterTagCount = 0;

				for (var x = 0; x < self.facets.length; x++) 
				{
					self.facets[x].isOpen = false;
					Vue.set(self.facets[x], 'showMore', false);

					for (var y = 0; y < self.facets[x].checkboxes.length; y++) 
					{
						if(self.facets[x].checkboxes[y].isEnabled)
						{
							self.catlist.push(self.facets[x].checkboxes[y].id);
							self.showFilters = true;
							self.facets[x].isOpen = true;
							self.filterTagCount += 1;
							if(self.filterTagCount < 7)
								Vue.set(self.facets[x].checkboxes[y], 'showFilterTag', true);
						}
						else if(self.facets[x].type == 'DateRanges' && (self.qsData.StartDate || self.qsData.EndDate))
						{
							self.facets[x].isOpen = true;
							self.filterTagCount += 1;
							if(self.filterTagCount < 7)
								Vue.set(self.facets[x].checkboxes[y], 'showFilterTag', true);
						}
					}
				}
				
				if(self.qsData.StartDate || self.qsData.EndDate)
					self.showFilters = true;
				
			},

			// toggles the drop downs for facet buckets
			toggleDrop: function (id, event) {
				const self = this;

				if (event) {
					if (self.facets[id].isOpen)
						self.facets[id].isOpen = false;
					else
						self.facets[id].isOpen = true;
				}
			},

			// this function toggles the checkboxes in the facets on the left
			toggleFacet: function (id, facetIndex, event) {
				const self = this;

				if (event) {
					// turn off filters to avoid confusion at this point; we haven't refreshed the search engine
					self.showFilters = false;

					// if we find one that has a SelectOne class, we need to toggle off all the other ones.
					// archived: using radio buttons now
//					var parentList = event.target.parentElement.parentElement.parentElement;
//					var checkClass = /SelectOne/;
//					if(parentList.getAttribute('class').match(checkClass))
//					{
//						for (var y = 0; y < self.facets[facetIndex].checkboxes.length; y++) 
//						{
//							// remove from catlist
//							self.catlist = self.removeQsList(self.catlist, self.facets[facetIndex].checkboxes[y].id);
//
//							if(self.facets[facetIndex].checkboxes[y].id != id)
//								self.facets[facetIndex].checkboxes[y].isEnabled = false;
//						}
//					}
					if(event.target.parentElement.getAttribute('class') == 'label--checked')
						self.findAndSetCB_short(id, facetIndex, false);
					else
						self.findAndSetCB_short(id, facetIndex, true);
				}
			},

			selectRadio: function(id, facetIndex, event) {
				const self = this;

				if(event)
				{
					// turn off filters to avoid confusion at this point; we haven't refreshed the search engine
					self.showFilters = false;

					// remove all filters from the rbl section
					for (var y = 0; y < self.facets[facetIndex].checkboxes.length; y++) 
					{
						self.catlist = self.removeQsList(self.catlist, self.facets[facetIndex].checkboxes[y].id);
						self.facets[facetIndex].checkboxes[y].isEnabled = false;
					}

					// then set this one
					self.findAndSetCB_short(id, facetIndex, true);

					// !!! refresh search 
					self.refreshResults(1, true);
				}
			},

			// this happens when a user chooses a new tag in the search results to add to their criteria
			selectTag: function(id, event) {
				const self = this;

				if(event)
				{
					// have to search all facets here; not sure which cat id to choose
					self.findAndSetCB_long(id, true);

					// !!! refresh search 
					self.refreshResults(1, true);
				}
			},

			// function to remove a filter tag, which are on top of the search results listed out.
			filterRemove: function(id, facetIndex, event) {
				const self = this;

				if(event)
				{
					self.findAndSetCB_short(id, facetIndex, false);

					// !!! refresh search 
					self.refreshResults(1, true);
				}
			},

			// removes all filters, see above
			filterRemoveAll: function(event) {
				const self = this;

				if(event)
				{
					// remove additional filters
					self.qsData.StartDate = '';
					self.qsData.EndDate = '';

					// loop to remove all facets and checkboxes from all queues
					for (var x = 0; x < self.facets.length; x++) 
					{
						for (var y = 0; y < self.facets[x].checkboxes.length; y++) 
						{
							if(self.facets[x].checkboxes[y].isEnabled)
								self.adjustQsCats(x, y, false);
						}
					}

					// !!! refresh search 
					self.refreshResults(1, true);
				}
			},
			// private, helper functions for setting cb values
			findAndSetCB_short: function(id, facetIndex, isEnabled) {
				const self = this;

				for (var y = 0; y < self.facets[facetIndex].checkboxes.length; y++) 
				{
					if(self.facets[facetIndex].checkboxes[y].id == id)
					{
						self.adjustQsCats(facetIndex, y, isEnabled);
						if (window.matchMedia('(max-width: 992px)').matches) {
							self.refreshResults(1, true);
						}
						else {
							Vue.set(self.facets[facetIndex], 'latestChangedCheckbox', y);
						}
						self.facets[facetIndex].checkboxes[y].dataChanged = true; // set facet data to changed so that we show a button to apply changes
					}
				}
			},

			findAndSetCB_long: function(id, isEnabled) {
				const self = this;

				for (var x = 0; x < self.facets.length; x++) 
				{
					for (var y = 0; y < self.facets[x].checkboxes.length; y++) 
					{
						if(self.facets[x].checkboxes[y].id == id)
							self.adjustQsCats(x, y, isEnabled);
					}
				}
			},

			adjustQsCats: function(facetIndex, checkboxIndex, isEnabled) {
				const self = this;
				self.facets[facetIndex].checkboxes[checkboxIndex].isEnabled = isEnabled;
				
				if(self.facets[facetIndex].type == 'Authors')
				{
					if(isEnabled)
						self.qsData.Authors.push(self.facets[facetIndex].checkboxes[checkboxIndex].id);
					else
						self.qsData.Authors = self.removeQsList(self.qsData.Authors, self.facets[facetIndex].checkboxes[checkboxIndex].id);
				}
				else if(self.facets[facetIndex].type == 'Private')
				{
					if(isEnabled)
						self.qsData.Private.push(self.facets[facetIndex].checkboxes[checkboxIndex].id);
					else
						self.qsData.Private = self.removeQsList(self.qsData.Private, self.facets[facetIndex].checkboxes[checkboxIndex].id);
				}
				else if(self.facets[facetIndex].type == 'Language')
				{
					// radio box
					if(isEnabled)
						self.qsData.Language = self.facets[facetIndex].checkboxes[checkboxIndex].id;
				}
				else if(self.facets[facetIndex].type == 'YearList')
				{
					if(isEnabled)
						self.currentYear = self.facets[facetIndex].checkboxes[checkboxIndex].id;
					else
						self.currentYear = '';
				}
				else
				{
					if(isEnabled)
					{
						var foundCat = false;
						for (var x = 0; x < self.catlist.length; x++) 
						{
							if(self.catlist[x] == self.facets[facetIndex].checkboxes[checkboxIndex].id)
								foundCat = true;
						}

						if(!foundCat)
							self.catlist.push(self.facets[facetIndex].checkboxes[checkboxIndex].id);
					}
					else
						self.catlist = self.removeQsList(self.catlist, self.facets[facetIndex].checkboxes[checkboxIndex].id);
				}
			},
			removeQsList: function(list, id) {
				for (var x = 0; x < list.length; x++)
				{ 
					if(list[x] == id)
						list.splice(x, 1);
				}

				return list;
			},

			doQuickDate: function(id) {
				const self = this;
				
				self.qsData.EndDate = moment();

				if(id == 6000)
				{
					self.qsData.StartDate = moment();
					self.qsData.EndDate = '';
				}
				else if(id == 6001)
					self.qsData.StartDate = moment().subtract(3, 'month');
				else if(id == 6002)
					self.qsData.StartDate = moment().subtract(6, 'month');
				else if(id == 6003)
					self.qsData.StartDate = moment().subtract(1, 'year');

				self.refreshResults(1, true);
			},

			changeDate: function() {
				const self = this;
				
				self.refreshResults(1, true);
			},

			startDateRemove: function() {
				const self = this;
				
				self.qsData.StartDate = '';
				self.refreshResults(1, true);
			},
			endDateRemove: function() {
				const self = this;
				
				self.qsData.EndDate = '';
				self.refreshResults(1, true);
			},
			bindMore: function(facetindex, checkboxindex) {
				const self = this;
				
				if(!self.facets[facetindex].showMore && self.facets[facetindex].type != 'Language' && checkboxindex >= 5)
					return 'hidden';
				else
					return '';
			},
			toggleMore: function(facetindex) {
				const self = this;
				
				Vue.set(self.facets[facetindex], 'showMore', true);
			},
			// pagination
			jumpToPage: function (jump, refreshCats, isInit) {
				const self = this;

				self.pagination.displayCount = parseInt(self.qsData.SelectDisplayCount, 10);
				self.pagingLoading = true;

				if (jump == 'next')
					self.pagination.currentIndex += self.pagination.displayCount;
				else if (jump == 'prev')
					self.pagination.currentIndex -= self.pagination.displayCount;
				else
					self.pagination.currentIndex = ((jump - 1) * self.pagination.displayCount) + 1;

				self.qsData.CurrentPageNum = (self.pagination.currentIndex - 1) / (self.pagination.displayCount) + 1;
				var lastPageNum = (self.pagination.pageCount - 1) / (self.pagination.displayCount) + 1;

				// setup page list of values
				if (self.pagination.currentIndex > 1) {
					if (lastPageNum > self.qsData.CurrentPageNum + 1) {
						self.pagination.listPages[0] = self.qsData.CurrentPageNum - 1;
						self.pagination.listPages[1] = self.qsData.CurrentPageNum;
						if (self.pagination.listPages.length > 2)
							self.pagination.listPages[2] = self.qsData.CurrentPageNum + 1;
						else
							self.pagination.listPages.push(self.qsData.CurrentPageNum + 1);
					}
					else if (self.pagination.listPages.length > 2) {
						self.pagination.listPages[0] = self.qsData.CurrentPageNum - 2;
						self.pagination.listPages[1] = self.qsData.CurrentPageNum - 1;
						self.pagination.listPages[2] = self.qsData.CurrentPageNum;
					}
				}

				// Update currentIndexTake
				if ((self.pagination.currentIndex + self.pagination.displayCount) > self.pagination.pageCount)
					self.pagination.currentIndexTake = self.pagination.pageCount;
				else
					self.pagination.currentIndexTake = self.pagination.currentIndex + self.pagination.displayCount - 1;

				// set pagination from form
				self.pagination.displayCount = parseInt(self.qsData.SelectDisplayCount, 10);

				// !!! refresh search 
				self.refreshResults(self.pagination.currentIndex, refreshCats, self.qsData.TargetType, isInit);
			},

			// {{{ functions to hit the server and refresh various elements
			initResults: function() {
				const self = this;
				const qs = urlVars();

				self.resultsLoading = true;
				self.qsData.TargetType = 'Pages';

				var initVal = initSearch.getAttribute('value');
				var initCat = initSearch.getAttribute('data-catid');
				var initCat2 = '';
				var initBlock = initSearch.getAttribute('data-blockid');
				var initPage = initSearch.getAttribute('data-page'); // not the current page in pagination; pulls stuff from page, like block above
				
				// set init lang
				self.loadPostData();

				if(qs['q'])
					initVal = qs['q'];
				if(qs['c'])
				{
					self.catlist = qs['c'].split(',');
					initCat = qs['c'];
				}
				if(qs['c2'])
					initCat2 = qs['c2'];

				var doLog = true;
				if(qs['qs'])
				{
					self.qsData = JSON.parse(decodeURIComponent(qs['qs']));
					doLog = false;
				}

				var initYear = '';
				if(qs['y'])
					initYear = qs['y'];

				request(options).post(initUrl + '?q=' + initVal + 
												'&c=' + initCat + 
												'&c2=' + initCat2 + 
												'&b=' + initBlock + 
												'&p=' + initPage + 
												'&y=' + initYear + 
												'&l=' + doLog + 
												'&qs=' + encodeURIComponent(JSON.stringify(self.qsData)), JSON.stringify(self.postData)).then(function(response) {

					// refresh local data
					self.resultsLoading = false;
					self.searchResults = response.currentData.searchResults;
					self.bestBetsResults = response.currentData.bestBetsResults;
					self.refreshTags();
					self.trackId = response.trackId;
					self.displayText = response.currentData.searchText;
					self.loadData(response.currentData);

					setTimeout(self.refreshTags, 500);
					console.log(self.bestBetsResults);
							
					if(qs['qs'])
						self.jumpToPage(self.qsData.CurrentPageNum, true, true);
					else
					{
						self.pagination = response.currentData.pagination;
						self.pagingLoading = false;
						self.facetsLoading = false;
					}

					self.loadPostData();
				});
			},
			refreshResults: function(currentIndex, refreshCats, targetType, isInit) {
				const self = this;

				// metrics
				self.qsData.metricsLogGUID = initSearch.getAttribute('data-metriclogid');

				// show loading modules
				self.resultsLoading = true;
				if(refreshCats)
					self.facetsLoading = true;

				// set pagination from form
				self.pagination.sortBy = self.qsData.SelectSort;
				self.pagination.displayCount = parseInt(self.qsData.SelectDisplayCount, 10);
				self.pagination.currentIndex = currentIndex;

				// check target types
				if(targetType != null)
					self.qsData.TargetType = targetType;

				var url = '?q=';
					
				if(self.searchText)	
					url += encodeURI(self.searchText);

				// get cats
				if(self.catlist.length > 0)
					url += '&c=' + self.catlist.join();

				if(self.currentYear.length > 0)
					url += '&y=' + self.currentYear;

				self.qsData.CurrentPageNum = (self.pagination.currentIndex - 1) / (self.pagination.displayCount) + 1;

				url += '&qs=' + encodeURIComponent(JSON.stringify(self.qsData));

				if(!isInit)
					window.history.pushState(null ,'', url);

				self.loadPostData();

				// always refresh main results
				request(options).post(refreshUrl, JSON.stringify(self.postData)).then(function(response) {

					// refresh local data
					self.searchResults = response.currentData.searchResults;
					self.bestBetsResults = response.currentData.bestBetsResults;
					self.refreshTags();
					self.resultsLoading = false;
					self.displayText = self.postData.SearchText;
					setTimeout(self.refreshTags, 1);

					// refresh page count
					request(options).post(refreshPagingUrl, JSON.stringify(self.postData)).then(function(pageresponse) {
						self.pagination = pageresponse;
						self.pagingLoading = false;
					});

					// once we return, do a full refresh if necessary; cats and facets
					if(refreshCats)
					{
						request(options).post(refreshFacetsUrl, JSON.stringify(self.postData)).then(function(facetresponse) {

							// refresh local data
							self.loadData(facetresponse);
							self.facetsLoading = false;
						});

					}
				});
			},
			// }}}
			loadPostData: function() {
				const self = this;

				// compose object to send back to server
				self.postData = {
					Facets: self.facets,
					Pagination: self.pagination,
					SearchText: self.searchText,
					PageType: self.pageType,
					TargetType: self.qsData.TargetType,
					AlwaysInclude: self.alwaysInclude,
					AlwaysPageRoot: self.alwaysPageRoot,
					StartDate: self.qsData.StartDate,
					EndDate: self.qsData.EndDate,
                    MetricsLogGUID: self.qsData.metricsLogGUID,
                    SearchAllSites: self.searchAllSites,
					CurrentLanguage: currentLang(),
				};
			},
			doScroll: function () {
				// animate the scroll to top (taken from BF)
				var scrollY = window.scrollY || document.documentElement.scrollTop,
					scrollTargetY = scrollTargetY || 0,
					speed = speed || 2000,
					easing = function easeInOutQuint(pos) {
						if ((pos /= 0.5) < 1) {
							return 0.5 * Math.pow(pos, 5);
						}
						return 0.5 * (Math.pow((pos - 2), 5) + 2);
					},
					currentTime = 0;

				// min time .1, max time .8 seconds
				var time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));

				// add animation loop
				function tick() {
					currentTime += 1 / 60;

					var p = currentTime / time;
					var t = easing(p);

					if (p < 1) {
						raf(tick);

						window.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
					} else {
						window.scrollTo(0, scrollTargetY);
					}
				}

				// call it once to get started
				tick();
			},
			refreshTags: function() {
				const self = this;

				for(var i = 0; i < self.searchResults.length; i++)
				{
					Vue.set(self.searchResults[i], 'showAllTags', false);
				}
			},
			trackClick: function(hitId) {
			    const self = this;
			    var hit = { 
			        query: self.searchText,
			        hitId: hitId, 
			        trackId: self.trackId, 
			    }; 
                
			    request(options).post(clickTrackingUrl, JSON.stringify(hit))
			    return false;
			}
		}
	});
}

//const filterOpenButton = document.querySelectorAll('.js-filter-open');
//const filterCloseButton = document.querySelectorAll('.js-filter-close');

//// Filter Button
//if(filterOpenButton.length > 0){
////	const openSearchMenu = (event) => {
////		event.currentTarget.nextElementSibling.setAttribute('data-open', true)
////		changeClass.addClass('body','body--FREEZE');
////	}
////	const closeSearchMenu = (event) => {
////		event.currentTarget.parentElement.removeAttribute('data-open')
////		changeClass.removeClass('body','body--FREEZE');
////	}
//
//	filterOpenButton[0].addEventListener('click', (event)=>{
//		alert('fire');
////		openSearchMenu(event);
//	}, false);
//
////	filterCloseButton[0].addEventListener('click', (event)=>{
////		alert('fire2');
////		closeSearchMenu(event);
////	}, false);
//}




// WEBPACK FOOTER //
// ../components/search/search.js